<template>
  <div>
    <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype">替换试题</div>
    </div>

    <!-- <div class="testlist2">
      <div class="testlistcontent">题型合集</div>
      <div class="testlistcontent_allitem">
        <div
          class="testlistcontent_item"
          v-for="(item, index) in isshowcheckList"
          :key="index"
        >
          <span>
            {{ item.StyleName }}
          </span>
          <span>
            {{ item.count }}
          </span>
        </div>
      </div>
      <div class="testlistcontent_bottom">
        <div class="testlistcontent_item">
          <span> 合计 </span>
          <span> {{ selecttest }}题 </span>
        </div>
      </div>
    </div> -->
    <div class="baic_content" v-loading="isloading">
      <!-- 添加题库按钮 -->
      <!-- <div v-if="isaddtest">
        <div class="addtestbtn">
          <div class="addtestbtncontent1" @click="addquestionbank"></div>
        </div>
        <h4>添加题库</h4>
      </div> -->
      <!-- 题库列表 -->
      <div class="testtypebutton">
        <!-- 切换按钮 -->
        <button
          class="testtypebtn"
          :class="{ isactivetype: testtype === '1' }"
          @click="changetesttype('1')"
        >
          平台题库
        </button>
        <!-- <button
          class="testtypebtn"
          :class="{ isactivetype: testtype === '0' }"
          @click="changetesttype('0')"
        >
          自定义题库
        </button> -->
      </div>
      <!-- <div class="testtypebutton_content">
        <div class="seriesof">
          <h4>已选系列</h4>
          <div class="seriesofbtnac">
            <div
              class="seriesofbtn"
              v-for="(item, index) in getdata"
              :key="index"
            >
              <button
                :class="{ isselect: cssisselect0 == index }"
                @click="isselect0(index, item)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="seriesof specilseriesof">
          <h4>已选类别</h4>
          <div class="seriesofbtnac">
            <div
              class="seriesofbtn"
              v-for="(item, index) in category"
              :key="index"
            >
              <button
                :class="{ isselect: cssisselect1 === index }"
                @click="isselect1(index, item)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="seriesof">
          <h4>已选科目</h4>
          <div class="seriesofbtnac">
            <div
              class="seriesofbtn"
              v-for="(item, index) in subjects"
              :key="index"
            >
              <button
                :class="{ isselect: cssisselect2 === index }"
                @click="isselect2(index, item)"
              >
                {{ item.label }}
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 选择试题列表 -->
      <div class="question_content">
        <h4 class="select">选择题库</h4>
        <div class="question_contents">
          <div class="questions">
            <h5>平台题库</h5>
            <div class="alltest">
              <div class="alltest1">
                <div class="alltestlist">
                  <el-checkbox v-model="allfirstcheckList"
                    >全部试题（50）</el-checkbox
                  >
                </div>
                <!-- <el-tree
                  :data="options"
                  node-key="id"
                  :default-expanded-keys="[2, 3]"
                  :default-checked-keys="[5]"
                  :props="defaultProps"
                  icon-class="el-icon-arrow-right"
                  @node-click="getthreed"
                >
                  <div class="custom-tree-node" slot-scope="{ node }">
                    <span>{{ node.label }}</span>
                    <i class="el-icon-arrow-right"> </i>
                  </div>
                </el-tree> -->
                <div
                  class="EXamalltest"
                  v-for="(item, index) in options"
                  @click="getthreedid(item.id)"
                  :key="index"
                >
                  {{ item.label }}
                </div>
              </div>
              <div class="alltest2">
                <div class="alltest2_content alltest2_content_title">
                  <el-checkbox label="全部题型"></el-checkbox>
                  <p>({{ reducecount }})</p>
                </div>
                <p v-if="reducecount == 0">当前章节下没有题型，请更换章节</p>
                <div
                  class="alltest2_content"
                  v-for="(item, index) in testtypedata"
                  :key="index"
                >
                  <p>{{ item.StyleName }}</p>
                  <p>({{ item.count }})</p>
                  <i class="el-icon-arrow-right towardsright"> </i>
                </div>
              </div>
              <div class="alltest3">
                <div class="alltest2_content alltest2_content_title">
                  <el-checkbox label="章节列表"></el-checkbox>
                </div>
                <el-radio-group
                  v-model="checkList1"
                  @change="childrenhandleCheckAllChange"
                >
                  <el-collapse accordion>
                    <el-collapse-item
                      v-for="(items, indexs) in testtypedatacontent"
                      :key="indexs"
                    >
                      <template slot="title" class="collapse_header">
                        <el-radio
                          :label="items.TestJson.ID"
                          class="checkboxyuansheng"
                        ></el-radio>
                        <!-- <p>{{ item.TestJson.Title }}</p> -->
                        <div
                          v-if="
                            items.TestJson.TestType === 'ATEST' ||
                            items.TestJson.TestType === 'XTEST' ||
                            items.TestJson.TestType === 'TKTEST' ||
                            items.TestJson.TestType === 'PDTEST' ||
                            items.TestJson.TestType === 'JDTEST'
                          "
                        >
                          {{ indexs + 1 + "." + items.TestJson.Title }}
                        </div>

                        <div
                          v-if="items.TestJson.TestType === 'BTEST'"
                          class="btest"
                        >
                          <div
                            v-for="(itemz, indexz) in items.TestJson.BTestItem"
                            :key="indexz + '' + indexs"
                            class="btestcontent"
                          >
                            {{ indexz + 1 + "." + itemz.Title }}
                          </div>
                        </div>

                        <div
                          v-if="items.TestJson.TestType === 'A3TEST'"
                          class="btest"
                        >
                          {{ indexs + 1 + "." + items.TestJson.MainTitle }}
                        </div>
                      </template>

                      <div
                        class="Aoptions"
                        v-if="
                          items.TestJson.TestType === 'ATEST' ||
                          items.TestJson.TestType === 'XTEST' ||
                          items.TestJson.TestType === 'TKTEST' ||
                          items.TestJson.TestType === 'PDTEST' ||
                          items.TestJson.TestType === 'JDTEST'
                        "
                      >
                        <p
                          v-for="(item, index) in items.TestJson.SelectedItem"
                          :key="index"
                          :class="{
                            istrue:
                              items.TestJson.Answer.indexOf(sumcount(index)) !=
                              -1,
                          }"
                          class="Aoptioncontent"
                        >
                          {{ sumcount(index) }}、{{ item }}
                        </p>
                        <div class="Aanswer">
                          答案: {{ items.TestJson.Answer }}
                        </div>
                      </div>

                      <div
                        class="options"
                        v-if="items.TestJson.TestType === 'BTEST'"
                      >
                        <p
                          v-for="(itemq, indexq) in items.TestJson.SelectedItem"
                          :key="indexq"
                          :class="{
                            istrue:
                              answerreduce(items.TestJson.BTestItem).indexOf(
                                sumcount(indexq)
                              ) != -1,
                          }"
                        >
                          {{ sumcount(indexq) }} {{ itemq }}
                        </p>
                        <div>
                          答案: {{ answerreduce(items.TestJson.BTestItem) }}
                        </div>
                      </div>

                      <div
                        class="options"
                        v-if="items.TestJson.TestType === 'A3TEST'"
                      >
                        <div
                          v-for="(iteme, indexe) in items.TestJson.A3TestItem"
                          :key="indexe"
                        >
                          <h4>（）{{ indexe + 1 }}{{ iteme.Title }}</h4>
                          <p
                            v-for="(itemt, indext) in iteme.SelectedItem"
                            :key="indext"
                            :class="{
                              istrue:
                                iteme.Answer.indexOf(sumcount(indext)) != -1,
                            }"
                          >
                            {{ sumcount(indext) }} {{ itemt }}
                          </p>
                          <div>答案: {{ iteme.Answer }}</div>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </el-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="operation">
      <el-button
        class="succ_btn"
        @click="
          cutcoms(1);
          destroy();
        "
        >返回试卷</el-button
      >
      <el-button type="success" class="submit_btn" @click="selecttestid"
        >选择试题</el-button
      >
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import qs from "qs";
import loginvuex from "@/store/index";
import { date } from "@/state/testtype"; //模拟请求的数据
import qusetionfcuntion from "@/api/questionbank"; //请求题库
import editqusetionbank from "@/api/editqusetionbank";
export default {
  props: ["cutcoms"],
  data() {
    return {
      isnowselect: "", //第二步点击需要渲染的题型
      isaddtest: true, //添加题库按钮的显示与隐藏true就是显示，false就是隐藏
      //这里可以采用树形图来做，先采用原生方法处理一次。
      firstcheckList: [], //第一层选中框选中的value值、
      testtype: "1",
      cssisselect0: "", //第一个按钮选中。
      cssisselect1: "",
      cssisselect2: "",
      getdata: [],
      SelectedApp: "", //选中的全体章数据 ④部生成的需要的数据
      SelectCpt: "", //选中的全体章节数据 ④部生成的需要的数据
      groupmode: "", //组卷模式
      unified: "", //统一命题
      isselectsubjects: "", //当前选取的科目的名称例如:SJSTJ_YSFCDEB
      isloading: false,
      val: [
        ["东南", "上海", "普陀"],
        ["东南", "上海", "黄埔"],
      ],
      seriesof: ["医学三基", "住院医师", "主任医师", "招聘考试", "私密题库"], //已选系列数据 第一层，第一层和第二层存在关联，
      category: [
        //已选类别  第二层
        "已选临床“三基”训练分册试题集",
        "主任医师",
        "招聘考试",
        "招聘考试",
      ],
      subjects: ["医师分册试题集", "主任医师", "招聘考试"], //已选科目  第三层是第二层点击后请求的数据
      options: [
        //选择完题库之后返回的树形结构数据。
        {
          value: 1,
          label: "1.医学高级",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "2.主治医生",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      testtypedata: [
        {
          Type: "ATEST",
          StyleName: "A型题",
          count: 12,
        },
        {
          Type: "XTEST",
          StyleName: "X型题",
          count: 12,
        },
        {
          Type: "TKTEST",
          StyleName: "填空题",
          count: 12,
        },
        {
          Type: "PDTEST",
          StyleName: "判断题",
          count: 12,
        },
        {
          Type: "JDTEST",
          StyleName: "名词解释",
          count: 12,
        },
        {
          Type: "JDTEST",
          StyleName: "问答题",
          count: 12,
        },
        {
          Type: "BTEST",
          StyleName: "B型题",
          count: 12,
        },
      ],
      selectreducecount: 0, //合集题型
      reducecount: 0, //全部题型总数
      SelectTestArr: [], //已经选中的题型。[{"CptID":"108802","softID":"SJSTJ_YSFCDEB","testID":["6726728"],"styleID":["5003"]}], 要发送给的数据在这里面拼接
      isshowcheckList: [], //悬浮选中的列表
      checkList: [], //选中题型的数组的string
      checkListID: [], //选中题型的数组的ID
      historycheckList: [], //历史选中题型的数组
      removeallcheckbox: 0, //取消全选按钮的状态，0是增加状态，1是取消减少状态
      isremoveoraddarr: [], //取消移除功能中要移除的数组,或者添加的数组
      checkList1: [], //选中章节列表
      testtypedatacontent: [], //渲染的手风琴数据
      alltesttypedatacontent: [], //请求到的全部手风琴数据
      defaultProps: {
        //树形组卷默认展示的节点和子节点
        children: "Childs",
        label: "Name",
      },
    };
  },
  methods: {
    totesttypedata(e) {
      //!!!!!!!!!!!!!!!!!!!!!第二次采用点击的方式，思想是点击第一级，第二级数据动态改变，第二级默认展示第一个，然后开始展示第三级。
      this.options = e;
      this.getthreedid(this.options[0].id)
      //   console.log(e);
      //   this.SelectedApp = a; //选中的全体不题型。
      //   this.getdata = e;
      //   console.log(this.getdata);
      //   this.isselect0(0, this.getdata[0]);
      //   this.isselect1(0, this.getdata[0].children[0]);
      //   console.log(this.getdata[0].children[0].children[0]);
      //   this.isselect2(0, this.getdata[0].children[0].children[0]);
      // this.seriesof = e.map((item) => {
      //   return item.label; //弹窗弹，对三级数据的第一级进行初始化第一次显示，这个时候还不知道第二级数据是啥，只有任意点击了一个按钮之后，才会显示第二级数据。
      // });
      // // console.log(this.getdata[index].children);
      // // this.isselect0(0,this.getdata[index].children);
      // //  console.log(this.seriesof);
      // this.category = e[0].children.map((item) => {
      //   //但是这里采用默认第一次选中第一个按钮，第二级菜单就展示的是第一级菜单点击第一个按钮的状态，
      //   return item.label;
      // });
      // this.isselect1(0);
      // this.subjects = e[0].children[0].children.map((item) => {
      //   //这里也是采用默认第一次选中后的数据，第三级菜单就采用第二级选中后的数据，然后就显示第三级。
      //   return item.label;
      // });
    },
    addquestionbank() {
      this.$refs.addtestdialog.dialogVisible = true; //开启弹窗
      // console.log(this.$refs.addtestdialog.dialogVisible);
    },
    // 试题设置弹窗
    addtextSon() {
      this.$refs.addtextSon.dialogVisibleSon = true; // 开启弹窗
      // console.log( this.$refs.addtextSon.dialogVisibleSon,'滴滴滴')
    },
    changetesttype(type) {
      if (this.testtype !== type) {
        if (this.testtype === "1") {
          this.testtype = "0";
        } else {
          this.testtype = "1";
        }
      }
    },
    isselect0(index, items) {
      //第一级按钮，按钮点击后标识为选中状态
      this.cssisselect0 = index;
      this.category = items.children;
      this.isselect1(0, items.children[0]);
    },
    isselect1(index, items) {
      //第二级按钮，按钮点击后标识为选中状态
      this.cssisselect1 = index;
      this.subjects = items.children;
      // console.log("第二级按钮", items);
      this.isselect2(
        0,
        this.getdata[this.cssisselect0].children[index].children[0]
      );
    },
    async isselect2(index, items) {
      //第三级按钮，按钮点击后标识为选中状态
      this.cssisselect2 = index;
      // console.log(items.AppEName);
      this.isselectsubjects = items.AppEName;
      let res = await qusetionfcuntion.getChapterMenu(items.AppEName);
      // console.log(res);
      this.options = res.data.Data.Childs;
      // console.log(res.data.Data.Childs[0].Childs[0].Childs[0]);
      let Imitative = new Object();
      Imitative.childNodes = [];
      this.getthreed(res.data.Data.Childs[0].Childs[0].Childs[0], Imitative);
      //这种请求的时候。要是分册试题集数据有问题。
      // return res.data.Data.Childs[0].Childs[0].Childs[0];
      //this.options.push(res.da.Data)
    },
    nexttothree() {
      //this.cutcoms(2);
      // try {
      //   //  this.selectChapter[`${this.selelctChapterone}`] = selectleafnodearr;
      //   console.log(this.SelectTestArr); //封装好的数据，选取好的章节。
      //   //在这里处理筛选出来testID
      //   let filterarr = this.SelectTestArr.filter((item) => {
      //     return item.testID.length != 0;
      //   }); //过滤掉空的
      //   //这里要重新处理一下
      //   let newstyleidarr = filterarr.map((item) => {
      //     return item.styleID;
      //   });
      //   newstyleidarr = newstyleidarr.flat(2);
      //   console.log(newstyleidarr);
      //   filterarr.map((item) => {
      //     item.styleID = newstyleidarr;
      //   });
      //   filterarr.map((item) => {
      //     item.testID = item.testID.map((zitem) => {
      //       zitem = String(zitem);
      //       return zitem;
      //     });
      //     item.styleID = item.styleID.map((sitem) => {
      //       sitem = String(sitem);
      //       return sitem;
      //     });
      //   });
      //   console.log(filterarr);
      //   let CookieCpt = {};
      //   filterarr.map((item) => {
      //     CookieCpt[item.softID] = [];
      //   });
      //   //  console.log(CookieCpt);
      //   filterarr.map((item) => {
      //     for (const key in CookieCpt) {
      //       if (key == item.softID) {
      //         CookieCpt[key].push(item.CptID);
      //       }
      //     }
      //   });
      //   console.log(CookieCpt);
      //   // for (const key in CookieCpt) {
      //   //  CookieCpt[key]=   CookieCpt[key].flat(2);
      //   // }
      //   // console.log(CookieCpt);//到这里就组好了CookieCpt
      //   // let SelectCpt = this.SelectTestArr.map((item) => {
      //   //   return item.CptID;
      //   // });
      //   // console.log(SelectCpt);
      //   let SelectCptarr = []; //这个地方是根据SJSTJ_YSFCDEB也就是我这里的CookieCpt分开传的
      //   for (let key in CookieCpt) {
      //     SelectCptarr.push(CookieCpt[key]);
      //   }
      //   console.log(SelectCptarr);
      //   let testIDarr = filterarr.map((item) => {
      //     return item.testID;
      //   });
      //   testIDarr = testIDarr.flat(2);
      //   // testIDarr = testIDarr.map((item)=>{
      //   //   return String(item)
      //   // })
      //   console.log(testIDarr);
      //   this.$parent.pagetwodata = filterarr;
      //   this.$parent.pagetworeq44 = CookieCpt;
      //   this.$parent.pagetworeq22 = testIDarr;
      //   this.$parent.pagetworeq33 = SelectCptarr;
      //   this.$parent.pagetworeq11 = this.SelectedApp; //这里将数据发送给父组件
      // } catch (error) {
      //   console.log(error);
      //   this.$message.error("没有添加题库");
      // }
      // // console.log(this.$parent);
    },
    async selecttestid() {
      if (this.checkList1.length == 0) {
        this.$message({
          message: "没有选择替换的提醒",
          type: "warning",
        });
        return;
      }
      // console.log(this.isnowselect.PaperTestID);
      // console.log("选择好的题型；", this.checkList1);
      let parmas = {
        paperID: this.$parent.testinfomation.PaperID,
        SourceTestIDArr: this.checkList1,
        PaperTestID: this.isnowselect.PaperTestID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        _examID: this.$parent.testinfomation.ExamID,
      };
      // console.log(parmas);
       let res = await qusetionfcuntion.SaveManualTest(qs.stringify(parmas));
      // console.log(res);
      if (res.data.Status == 200) {
        this.$message({
          message: "替换数据成功",
          type: "success",
        });
        this.cutcoms(1);
      }
    },
    destroy() {
      this.$destroy();
    },
    async getthreedid(id) {
      let parmars = {
        clickMainPaperID: id, //当前试卷ID从这里传。
        _examID: this.$parent.testinfomation.ExamID,
        paperID: this.$parent.testinfomation.PaperID,
        Type: this.isnowselect["TestJSON"].TestType, //题型格式
        SourceTestID: this.isnowselect.PaperTestID, //题型ID
        userID: JSON.parse(loginvuex.state.userlist).userID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      let res = await qusetionfcuntion.ManualTest(parmars);
      console.log(res.data.Data.length);
      if(res.data.Data.style === undefined){
        this.$message.error('当前试卷下没有题型，请更换试卷')
        return
      }
      this.testtypedata = res.data.Data.style; //题型列表渲染
      this.reducecount = this.testtypedata.reduce((first, scend) => {
          //  console.log(first);
          //    console.log(scend);
          return first + scend.count;
        }, 0);
      this.alltesttypedatacontent = res.data.Data.test.map((item) => {
        item.TestJson = JSON.parse(item.TestJson);
        if (item.TestJson.Answer == undefined) {
          item.TestJson.Answer = ""; //给一个Answer为空的处理。
        }
        return item;
      });
      console.log(this.alltesttypedatacontent);
      this.testtypedatacontent = this.alltesttypedatacontent;
      console.log(res);
      //在这里吧数据传输进来。
    },
    async getthreed(a, b, c) {
      //   console.log(a); //对应的对象
      //  console.log(b); //节点对应的 Node  ,,只有当对应节点数的子节点数组为0的时候，才开始传值
      //  console.log(c); //节点组件本身。
      // console.log("进来");
      this.removeallcheckbox = 0; //默认是增加
      console.log(this.isshowcheckList);
      if (b.childNodes.length === 0) {
        // console.log("进来2"); //这个地方插入科目的英文ID 和章节ID，对比这两个数值，
        //进来先查已经选择的数组里面是否已经存在了，再决定是否添加。
        let dangqiandianji = this.SelectTestArr.filter((item) => {
          return item.CptID == a.ID && item.softID == this.isselectsubjects;
        });
        this.SelectTestArr.map((item) => {
          item.isnowselect = false; //一进来，默认把之前的被点击状态都转为false.
        });
        console.log(dangqiandianji);
        if (dangqiandianji.length == 0) {
          //表示已经选择的数组内没有当前点击的数据
          let newtestobj = {};
          newtestobj.CptID = a.ID;
          newtestobj.softID = this.isselectsubjects;
          newtestobj.isnowselect = true; //表示当前选择的全部试题的第三级叶子节点的点击对象。
          newtestobj.testID = [];
          newtestobj.styleID = [];
          this.SelectTestArr.push(newtestobj);
        } else {
          this.SelectTestArr.map((item) => {
            if (item.CptID == dangqiandianji[0].CptID) {
              item.isnowselect = true;
            }
          });
        }
        // console.log(this.SelectTestArr); //数据在这里选择好
        // console.log(this.$parent.paperinfomation);
        let parmars = {
          clickMainPaperID: "", //当前试卷ID从这里传。
          _examID: this.$parent.testinfomation.ExamID,
          paperID: this.$parent.testinfomation.PaperID,
          Type: this.isnowselect["TestJSON"].TestType, //题型格式
          SourceTestID: this.isnowselect.PaperTestID, //题型ID
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          hid: JSON.parse(loginvuex.state.userlist).hid,
        };
        let res = await qusetionfcuntion.getTestByAppENameAndCptID(parmars);
        if (dangqiandianji.length == 0) {
          this.checkList = [];
          this.historycheckList = [];
          this.checkList1 = []; //这里清空一下全部题型已经选择的数据，
        } else {
          // console.log(dangqiandianji);
          if (dangqiandianji[0].styleID.length != 0) {
            this.checkList = dangqiandianji[0].styleID.map((item) => {
              // console.log(item);
              item = this.referidtostreing(item);
              // console.log(item);
              return item;
            });
            this.historycheckList = dangqiandianji[0].styleID.map((item) => {
              // console.log(item);
              item = this.referidtostreing(item);
              // console.log(item);
              return item;
            });
          } else {
            this.checkList = [];
            this.historycheckList = [];
          }
          // console.log(dangqiandianji);
          this.checkList1 = dangqiandianji[0].testID;
        }
        // console.log(this.checkList);
        // console.log(this.checkList1);
        //     console.log(res.data.Data.test);
        this.testtypedata = res.data.Data.style; //题型列表渲染
        // console.log(res.data.Data.style);
        this.reducecount = this.testtypedata.reduce((first, scend) => {
          //  console.log(first);
          //    console.log(scend);
          return first + scend.count;
        }, 0);
        
        this.alltesttypedatacontent = res.data.Data.test.map((item) => {
          item.TestJson = JSON.parse(item.TestJson);
          if (item.TestJson.Answer == undefined) {
            item.TestJson.Answer = ""; //给一个Answer为空的处理。
          }
          return item;
        });
        let abc = this.alltesttypedatacontent.map((item) => {
          //   console.log(item.TestJson.Answer == undefined); //有5行数据没有返回，undefined
          return item.TestJson.Answer;
        });
        //        console.log(abc);
        // console.log(this.alltesttypedatacontent);
        this.testtypedatacontent = this.alltesttypedatacontent; //首次渲染的时候渲染全部的未筛选数据
        // this.testtypedatacontent = res.data.Data.test; //章节列表渲染

        //到这个位置，接下来就是要把请求到的res的style给到题型列表
        //把题型列表当成筛选器，第三列章节列表就是筛选后的结果，点击是显示。勾选是后面的试题选中即题型列表勾勾就亮起。
        // console.log(this.SelectTestArr);
      }
    },
    // selecttesttype(testtype) {
    //   //   console.log(testtype);
    //   //   console.log(this.alltesttypedatacontent)
    //   this.testtypedatacontent = this.alltesttypedatacontent.filter((item) => {
    //     return item.StyleName == testtype;
    //   });
    // },
    handleCheckAllChange(val) {
      this.isremoveoraddarr = [];
      // console.log(val);
      this.removeallcheckbox = 0; //默认是增加
      // console.log(this.SelectTestArr);
      // console.log(this.historycheckList); //这个历史的checkList需要修改，
      if (val.length < this.historycheckList.length) {
        // console.log("减去的时候进来");
        //要判断一次当取消一个全选按钮的时候，
        this.isremoveoraddarr = this.getArrDifference(
          this.historycheckList,
          val
        );
        // console.log(this.isremoveoraddarr); //当取消checkbox的时候，拿到了要减去的数据了。
        //这里定义一个状态，是添加题型还是减少题型。
        this.removeallcheckbox = 1;
      } else {
        // console.log("//加的时候进来");
        // console.log(this.checkList);
        this.isremoveoraddarr = this.getArrDifference(
          this.historycheckList,
          val
        );
      }
      this.historycheckList = val;
      let b = this.testtypedata.filter((item) => {
        let bisselect = val.filter((zitem) => {
          return zitem === item.StyleName;
        });
        return bisselect.length !== 0;
      });
      let linshi = JSON.stringify(b);
      let genggai = JSON.parse(linshi); //上面这边主要是处理悬浮框的选中结果这里主要处理是的章节列表勾选选中的结果显示。 只把增加处理完了，全部减少还没处理完。
      // console.log(b); //这个b的数据需要再过滤一道，根据isshowcheckList里面已经选择的数据过滤一趟
      genggai.map((item) => {
        // console.log(item);
        if (this.isshowcheckList.length !== 0) {
          //第一次进来是空的，但是如果有单点的情况下。要进行count复制更改
          for (let i = 0; i < this.isshowcheckList.length; i++) {
            if (this.testtypedata[i].StyleName === item.StyleName) {
              // console.log(this.isshowcheckList[i]);
              item.count = this.isshowcheckList[i].count;
              //  return b[i]
            }
          }
        }
      });
      //   console.log(genggai);

      // console.log(this.isshowcheckList);
      //   console.log(onceallselect); //这里主要处理是的章节列表勾选选中的结果显示。 只把增加处理完了，全部减少还没处理完。
      if (this.removeallcheckbox == 0) {
        //当checkbox状态为0增加的时候，才添加数组。
        // console.log(this.isremoveoraddarr);
        let a = this.alltesttypedatacontent.filter((item) => {
          return item.StyleName == this.isremoveoraddarr[0];
        });
        let onceallselectid = a.map((item) => {
          return Number(item.TestID);
        });
        // console.log(a);
        // let onceallselect = a.map((item) => {
        //   //判断this.checkList 里有没有
        //   let istrueindex = this.isshowcheckList.findIndex((zitem, index) => {
        //     console.log("进来了s吗d啊");
        //     console.log(zitem);
        //     //  console.log();
        //     console.log(zitem.StyleName === item.StyleName);
        //     return zitem.StyleName === item.StyleName;
        //   });
        //   console.log(istrueindex);
        //   if (istrueindex === -1) {
        //     return item.TestJson.ID;
        //   } else {
        //     return "";
        //   }
        // });
        this.checkList1.push.apply(this.checkList1, onceallselectid);
        // console.log(this.checkList1);
      } else if (this.removeallcheckbox == 1) {
        //当checkbox状态为1取消减少的时候，开始减少数组。
        // console.log("进入减少数组的取消姐但");
        // console.log(this.isremoveoraddarr); //拿到需要取消的全体数据。
        let isremovearrdataid = this.alltesttypedatacontent.map((item) => {
          if (item.StyleName === this.isremoveoraddarr[0]) {
            return item.TestJson.ID;
          } else {
            return "";
          }
        });
        let trueisremovearrdataid = isremovearrdataid.filter((item) => {
          return item !== "";
        });

        // console.log(trueisremovearrdataid); //明天开始对比过滤checkboxList里面的数据。
        // console.log(this.checkList1);
        this.checkList1 = this.checkList1.map((item) => {
          let a = trueisremovearrdataid.find((zitem) => {
            return zitem == item;
          });
          // console.log(a);
          if (a == undefined) {
            return item;
          } else {
            return "";
          }
        });
        //  console.log(abc);
        //写到这里了，8.3拿到需要过滤掉的全部章节列表的ID，然后把checkList里面的数组ID里面含有被过滤的ID全部取消掉，就可以了。
      }
      this.checkList1 = this.checkList1.filter((item) => {
        return item !== "";
      });
      // console.log(this.checkList1);
      //  console.log(this.checkList);
      //console.log(this.referstringtoid("B型题"));
      this.checkListID = this.checkList.map((item) => {
        return this.referstringtoid(item);
      });
      //   console.log(this.checkListID);
      this.SelectTestArr.map((item) => {
        if (item.isnowselect == true) {
          item.testID = JSON.parse(JSON.stringify(this.checkList1));
          item.styleID = JSON.parse(JSON.stringify(this.checkListID));
        }
      });
      // console.log(genggai);
      this.isshowcheckList = genggai; //悬浮框是勾选后的数据
      // console.log(this.isshowcheckList);
    },
    childrenhandleCheckAllChange(val) {
      // console.log(val);
      // console.log(this.checkList1);
      //  console.log(this.alltesttypedatacontent);
      // let a = this.alltesttypedatacontent.filter((item) => {
      //   let isselect = val.filter((zitem) => {
      //     //   console.log(zitem + "zhognjian" + item.TestID);
      //     //  console.log('这是要打印的'+zitem);
      //     return zitem == item.TestID;
      //   });
      //   //  console.log(isselect);
      //   //  console.log(isselect.length !== 0);
      //   return isselect.length !== 0;
      // });
      // //   console.log(a);
      // let abc = a.map((item) => {
      //   return item.StyleName;
      // });
      // console.log(abc); //选中的章节题型
      // this.isshowcheckList = this.getCount(abc);
      // //  console.log(this.getCount(abc));
      // //  console.log(abc);
      // this.checkList = this.isshowcheckList.map((item) => {
      //   return item.StyleName;
      // });
      // this.checkList = this.filterlook(abc);
      // this.historycheckList = this.filterlook(abc);
      // console.log(this.checkList);
      // console.log(this.historycheckList);
      // console.log(this.checkList1);
      // this.checkListID = this.checkList.map((item) => {
      //   return this.referstringtoid(item);
      // });
      // console.log(this.checkListID);
      // this.SelectTestArr.map((item) => {
      //   if (item.isnowselect == true) {
      //     item.testID = JSON.parse(JSON.stringify(this.checkList1));
      //     item.styleID = JSON.parse(JSON.stringify(this.checkListID));
      //   }
      // });
    },
    //使用obj记录重复的元素.
    getCount(arr) {
      var obj = {},
        k,
        arr1 = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        k = arr[i];
        if (obj[k]) obj[k]++;
        else obj[k] = 1;
      }
      //           console.log(obj)
      //保存结果{el-'元素'，count-出现次数}
      for (var o in obj) {
        arr1.push({
          StyleName: o,
          count: obj[o],
        });
      }
      //console.log(arr1);
      return arr1;
    },
    //比较两个数组，比较出不用的部分。返回一个数组
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    //将题型数转化为题型的ID，其实是一开始没设计好，可以直接渲染ID
    referstringtoid(strings) {
      switch (strings) {
        case "A型题":
          return 5003;
          break;
        case "X型题":
          return 5004;
          break;
        case "填空题":
          return 5005;
          break;
        case "判断题":
          return 5006;
          break;
        case "名词解释":
          return 5007;
          break;
        case "问答题":
          return 5008;
          break;
        case "B型题":
          return 5009;
          break;
      }
    },
    //将题型数转化为题型的ID，其实是一开始没设计好，可以直接渲染ID
    referidtostreing(numbers) {
      switch (numbers) {
        case 5003:
          return "A型题";
          break;
        case 5004:
          return "X型题";
          break;
        case 5005:
          return "填空题";
          break;
        case 5006:
          return "判断题";
          break;
        case 5007:
          return "名词解释";
          break;
        case 5008:
          return "问答题";
          break;
        case 5009:
          return "B型题";
          break;
      }
    },
    filterlook(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    handleCheckChange(val) {
      //  console.log(val);  //这个单个按钮只返回true和false.
    },
    refersoftappr(abc) {
      let newdata = Object.keys(abc).map((item) => {
        let parmas = {};
        parmas.label = item.split("|")[0];
        parmas.id = item.split("|")[1];
        return parmas;
      });
      // console.log(newdata);
      return newdata;
    },
  },
  computed: {
    allfirstcheckList() {
      //这里对应父亲组卷的v-model。采用计算属性处理一次。
      if (this.firstcheckList.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    answerreduce() {
      return function (params) {
        //      console.log(params);
        if (params.length == 1) {
          return params[0].Answer[0]; //这个地方暂时只用数组内的一个答案为
        }
        let res = params.reduce((first, scend) => {
          //   console.log(first, "gvasfasfvasdasc", scend);
          if (typeof first === "string") {
            // console.log(first, "发撒撒旦", scend.Answer[0]);
            return first + scend.Answer;
          } else {
            return first.Answer + scend.Answer;
          }
          // if (first.splice !== undefined) {
          //   console.log(first.Answer,"第一次",scend.Answer);
          //   return first + scend;
          // } else {
          //   console.log(first.Answer,"sdadasfas",scend.Answer);
          //   console.log(first.Answer + scend.Answer);
          //   return first + scend.Answer[0];
          // }
        });
        //  console.log(res);
        return res;
      };
    },
    //题型计算合集
    selecttest() {
      let selectreducecount = this.isshowcheckList.reduce((first, scend) => {
        return first + scend.count;
      }, 0);
      return selectreducecount;
    },
    sumcount() {
      return function (index) {
        let a = index;
        switch (a) {
          case 0:
            return "A";
          case 1:
            return "B";
          case 2:
            return "C";
          case 3:
            return "D";
          case 4:
            return "E";
          case 5:
            return "F";
          case 6:
            return "G";
          case 7:
            return "H";
          case 8:
            return "I";
          case 9:
            return "J";
          case 10:
            return "K";
        }
        return a;
      };
    },
  },
  activated() {
    this.isloading = true;
    this.isnowselect = this.$parent.isselecttest;
    this.groupmode = this.$parent.testmode;
    this.unified = this.$parent.checkmode;
    // console.log(this.$parent.testinfomation.PaperID);
    setTimeout(() => {
      this.totesttypedata(
        this.refersoftappr(
          JSON.parse(this.$parent.paperinfomation[1].Config).SoftApp
        )
      );
      //  console.log(this.$parent.isselecttest.TestJson.TestType);
      this.isloading = false;
    }, 500);
  },
};
</script>

<style lang="scss" scoped>
.testlist {
  width: 200px;
  height: 211px;
  background-color: rgb(153, 111, 56);
  position: absolute;
}
.testlist2 {
  width: 320px;
  height: 387px;
  background: #ffffff;
  box-shadow: 0px 3px 15px #d8edff;
  opacity: 1;
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  position: sticky;
  transform: translate(1240px, 40px);
  top: 20px;
  left: 40px;
  z-index: 20;
  .testlistcontent {
    height: 58px;
    border-radius: 10px 10px 0px 0px;
    background-color: #1890ff;
    line-height: 58px;
    text-align: center;
    color: #ffffff;
  }
}
.testlistcontent_allitem {
  height: 264px;
  // background-color: rgba(255, 0, 0, 0.055);
}
.testlistcontent_bottom {
  border-top: 1px solid #eeeeee;
  height: 62px;
  //background-color: aquamarine;
}
.testlistcontent_item {
  display: flex;
  // background-color: aqua;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  color: #333333;
  font-size: 14px;
  font-family: PingFang SC;
}
.baic_content {
  z-index: 10px;
  //transform: translate(0px, -387px);
  min-width: 1527px;
  // padding-bottom: 50px;
  border-radius: 14px 14px 14px 14px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  h4 {
    text-align: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
  }
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
.showlabel {
  // transform: translate(0px, -200px);
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.addtestbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 370px;
  padding-top: 80px;
  background-color: #ffffff;
  & + h4 {
    background-color: #ffffff;
    padding-bottom: 100px;
  }
  .addtestbtncontent1 {
    width: 200px;
    height: 200px;
    background-image: url(../../../../../../assets/addtesttype.png);
    background-size: 100%;
    cursor: pointer;
    &:hover {
      width: 290px;
      height: 290px;
      background-image: url(../../../../../../assets/addtesttypeactive.png);
      background-size: 100%;
    }
  }
}
.testtypebutton {
  height: 93px;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.testtypebtn {
  width: 180px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #1890ff;
  font-family: PingFang SC;
  border: 1px solid#1890FF;
  border-radius: 5px 0px 0px 5px;
  &:nth-child(2) {
    border-left: none;
    border-radius: 0px 5px 5px 0px;
  }
  //border-radius: 0px 5px 5px 0px;
}
.isactivetype {
  color: #ffffff;
  background-color: #1890ff;
}
.testtypebutton_content {
  width: 100%;
  min-height: 420px;
  background-color: #ffffff;
  > :nth-child(1),
  > :nth-child(2) {
    h4 {
      border-bottom: 2px solid #afd9ff;
    }
    .seriesofbtnac {
      border-bottom: 2px solid #eeeeee;
    }
  }
  // // >:nth-child(3){
  // //       .seriesofbtnac{
  // //     border-bottom: 2px solid #EEEEEE;
  // //   }
  // }
}
.seriesof {
  width: 100%;
  min-height: 140px;
  display: flex;
  // background-color: aqua;
  h4 {
    width: 128px;
    // height: 100%;
    min-height: 140px;
    display: inline-block;
    text-align: center;
    line-height: 128px;
    background: #ebf6ff;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
.specilseriesof {
  height: auto;
  > :nth-child(2) {
    padding-top: 15px;
  }
}
.seriesofbtnac {
  width: calc(100% - 128px);
  //background-color: rosybrown;
  padding: 45px 0px 25px 0px;
}
.seriesofbtn {
  //  width: 100%;
  //  height: 100%;
  // background-color: blanchedalmond;
  margin-top: 5px;
  display: inline-block;
  // background-color: salmon;
  button {
    // width: 162px;
    padding-left: 49px;
    padding-right: 49px;
    height: 50px;
    border: 1px solid #bbbbbb;
    opacity: 1;
    border-radius: 4px;
    background-color: rgb(255, 255, 255);
    margin-left: 50px;
    margin-bottom: 16px;
    color: #aaaaaa;
    font-family: PingFang SC;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      border: 1px solid #1890ff;
      background-color: #badfff;
      color: #0084ff;
    }
  }
}
.isselect {
  //选中的列表
  border: 1px solid #1890ff !important;
  background-color: #badfff !important;
  color: #0084ff !important;
}
//下面是列表的样式
.select {
  height: 42px;
  background: #1890ff;
  margin-top: 20px;
  border-radius: 10px 10px 0px 0px;
  font-size: 15px !important;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 42px !important;
  padding-left: 24px;
  color: #ffffff !important;
  text-align: left !important;
}
.question_content {
  background-color: rgb(255, 255, 255);
  padding-bottom: 60px;
}
.question_contents {
  display: flex;
  .questions {
    width: 100%;
  }
  h5 {
    height: 60px;
    font-size: 18px;
    background: #cce7ff;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    line-height: 60px;
    padding-left: 14px;
  }
}

.alltest {
  height: 480px;
  // background-color: aquamarine;
  display: flex;
  border-bottom: 1px solid #eeeeee;
}
.alltest1 {
  width: 33%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  border-right: 1px solid #eeeeee;
  &::-webkit-scrollbar {
    display: none;
  }
}
.alltest2 {
  width: 33%;
  height: 100%;
  border-right: 1px solid #eeeeee;
}
.alltest2_content_title {
  font-family: PingFang SC; //这里标题字体等待更改
}
.alltest2_content {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  height: 52px;
  padding-left: 24px;
  padding-right: 20px;
  cursor: pointer;
  //  / background-color: blanchedalmond;
  border-bottom: 1px solid #eeeeee;
  > :nth-child(1) {
    padding-bottom: 3px;
    padding-left: 4px;
    min-width: 70px;
  }
  > :nth-child(2) {
    //  background-color: #0084ff;
    margin-left: 5px;
    margin-bottom: 5px;
    min-width: 100px;
  }
}
.towardsright {
  margin-left: 270px;
}
.scend {
  padding: 30px;
}
.threed {
  padding-left: 60px;
}
.testtpye {
  height: 52px;
  background-color: blanchedalmond;
}
.alltestlist {
  height: 52px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  line-height: 52px;
  padding-left: 24px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
}
.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  width: 90%;
  height: 52px;
  padding-right: 20px;
  > :nth-child(1) {
    padding-bottom: 3px;
    padding-left: 4px;
  }
}
::v-deep .el-tree-node__content {
  width: 100%;
  height: auto !important;
  > :nth-child(1) {
    margin-left: 24px;
    display: none;
  }
  > :nth-child(2) {
    margin-left: 24px;
  }
}
::v-deep .el-tree-node {
  border-bottom: 1px solid #eeeeee;
  > :nth-last-child(1) {
    border-bottom: none;
    //  background-color: blanchedalmond;
  }
}
::v-deep .is-expanded {
  //选中后添加的属性
  > :nth-child(1) {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%) !important;
    > :nth-child(3) {
      i {
        transform: rotate(90deg);
        transition: transform 0.3s ease-in-out;
      }
    }
  }
}
.alltest3 {
  width: 34%;
  height: 100%;
  //background-color: #d5e7f83b;
  overflow-x: hidden;
  overflow-y: scroll;
  border-right: 1px solid #eeeeee;
  &::-webkit-scrollbar {
    display: none;
  }
}
::v-deep .el-collapse-item__header {
  height: auto !important;
  padding-left: 24px;
  font-family: PingFang SC;
}
.checkboxyuansheng {
  // background-color: #0084ff;
  > :nth-child(2) {
    background-color: #0084ff;
    display: none;
  }
  & + p {
    // background-color: #0084ff;
    //  margin-left: 10px;
    font-weight: 400;
    font-family: PingFang SC;
  }
}
::v-deep .el-collapse-item__content {
  padding-bottom: 0 !important;
}
.testanswer {
  height: 42px;
  background: #d8edff;
  border: 1px solid #7bc2ff;
  line-height: 42px;
  color: #333333;
  font-family: PingFang SC;
  padding-left: 24px;
}
.trueanswer {
  color: #1890ff !important;
}
.collapse_content {
  padding-left: 24px;
  height: 30px;
  color: #999999;
}
::v-deep .el-radio-group {
  width: 100%;
}
::v-deep .el-radio__inner {
  display: inline-block !important;
  position: relative !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 2px !important;
  box-sizing: border-box !important;
  width: 14px !important;
  height: 14px !important;
  //  background-color: #FFF !important;
  z-index: 1 !important;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46) !important;
  &::after {
    box-sizing: content-box !important;
    content: "" !important;
    border: 1px solid #fff !important;
    border-left: 0 !important;
    border-top: 0 !important;
    height: 7px !important;
    left: 4px !important;
    position: absolute !important;
    top: 1px !important;
    border-radius: 0 !important;
    background-color: #409eff !important;
    //     transform: rotate(
    // 45deg
    // ) scaleY(0) !important;
    width: 3px !important;
    transition: transform 0.15s ease-in 0.05s !important;
    transform-origin: center !important;
  }
}
::v-deep .el-radio__input.is-checked .el-radio__inner::after {
  transform: rotate(45deg) scaleY(1) !important;
}

.Aoptions {
  // padding-left: 45px;
  .istrue {
    color: #1890ff;
  }
  .Aoptioncontent {
    margin-left: 50px;
    margin-bottom: 10px;
  }
  .Aanswer {
    padding: 11px 26px;
    background-color: #d8edff;
    border: 1px solid #7bc2ff;
  }
}
.EXamalltest {
  //background: red;
  height: 52px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
  padding-left: 20px;
  cursor: pointer;
  line-height: 52px;
}
</style>